var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTpWorkIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M24.5193 9.44219C24.9974 8.76468 26.0022 8.76468 26.4803 9.44219L45.4736 36.3582C46.0345 37.1532 45.466 38.2501 44.4931 38.2501H6.50648C5.53358 38.2501 4.96508 37.1531 5.52601 36.3582L24.5193 9.44219Z",
    fill: "#0e131c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1875 29.2187C20.1875 31.28 21.7813 32.9375 23.7363 32.9375H27.7312C29.4312 32.9375 30.8125 31.4925 30.8125 29.6863C30.8125 27.7525 29.9625 27.0513 28.7088 26.605L22.3125 24.3738C21.0588 23.9275 20.2088 23.2475 20.2088 21.2925C20.2088 19.5075 21.59 18.0413 23.29 18.0413H27.285C29.24 18.0413 30.8338 19.6988 30.8338 21.76",
    stroke: "#0e131c",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 15.9375V35.0625",
    stroke: "#0e131c",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.75 25.5C46.75 37.23 37.23 46.75 25.5 46.75C13.77 46.75 4.25 37.23 4.25 25.5C4.25 13.77 13.77 4.25 25.5 4.25",
    stroke: "#0e131c",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.75 12.75V4.25H38.25",
    stroke: "#0e131c",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.125 14.875L46.75 4.25",
    stroke: "#0e131c",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTpWorkIcon04);
export default __webpack_public_path__ + "static/media/tp-work-icon04.3abee5608a0f7e2ddd12e7312de70bae.svg";
export { ForwardRef as ReactComponent };